import { useState, useCallback ,useContext  } from 'react';
import { TableStateProvider } from '../model/table_state_context';
import TargetlistContainer from '../components/target_list/target_list_container';
import InfoPopup from "../components/info_popup";

export default function Targetlist() {
    const [popupVisible, setPopupVisible] = useState(false);

    const onPopupBlur = useCallback((e) => {
        var info = document.getElementById("info-popup");
        setPopupVisible(false);
        if (e.relatedTarget == null) {
            info.classList.remove("show");
        } else if (e.relatedTarget.id !== "info-popup" || e.relatedTarget.id == null){
            info.classList.remove("show");
        }
    }, [popupVisible]);

    return (
        <TableStateProvider>
            <InfoPopup toggleInfoPopup={onPopupBlur} />
            <TargetlistContainer />
        </TableStateProvider>

    );
}